<template>
  <div id="breadcrumb" v-if="firstMenuItem.i18nValue" class="breadcrumb">
    <div v-show="firstMenuItem.i18nValue" class="bread-item">
      <span class="name">{{ firstMenuItem.i18nValue || firstMenuItem.localName }}</span>
      <span class="arrow-right">
        <i class="icon-a-directorytree_03_right"></i>
      </span>
    </div>
    <div v-if="firstMenuItem.i18nValue && secondMenuItem.i18nValue" class="bread-item">
      <span class="name">{{ secondMenuItem.i18nValue || secondMenuItem.localName }}</span>
      <span class="arrow-right">
        <i class="icon-a-directorytree_03_right"></i>
      </span>    </div>
    <div v-if="firstMenuItem.i18nValue && secondMenuItem.i18nValue && thirdMenuItem.i18nValue" class="bread-item">
      <span class="name">{{ thirdMenuItem.i18nValue || thirdMenuItem.localName }}</span>
      <span class="arrow-right">
        <i class="icon-a-directorytree_03_right"></i>
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getMenuItemFromAllMenu } from '@/utils/menu';
import website from '@/config/website';
export default {
  props: {
    repeat: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters([
      'topMenuAll',
      'menuItem',
    ]),
    firstMenuItem() {
      const path = this.menuItem.path;
      const obj = getMenuItemFromAllMenu(this.topMenuAll, path);
      if (this.menuItem.local) {
        return this.menuItem;
      }
      return obj.itemA || {};
    },
    secondMenuItem() {
      const path = this.menuItem.path;
      const obj = getMenuItemFromAllMenu(this.topMenuAll, path);
      return obj.itemB || {};
    },
    thirdMenuItem() {
      const path = this.menuItem.path;
      const obj = getMenuItemFromAllMenu(this.topMenuAll, path);
      return obj.itemC || {};
    },
  },
  created() {
    this.updateBreadCrumb()
    // 页面定制面包屑导航则隐藏公共的面包屑导航
  },
  methods: {
    updateBreadCrumb() {
      const list = website.sidebarPages;
      if (list.includes(location.pathname.replace('/emp',''))) {
        this.$store.commit('CUSTOM_BREADCURMB', true); // 处理刷新情况
      } else {
        this.$store.commit('CUSTOM_BREADCURMB', false);
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>